import script from "./Remember.vue?vue&type=script&setup=true&lang=js"
export * from "./Remember.vue?vue&type=script&setup=true&lang=js"

import "./Remember.vue?vue&type=style&index=0&id=2fd8bd76&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd8bd76"]])

export default __exports__